import React, { Component } from 'react';
import auth from "../../../../Auth";
import { Grid, GridColumn, GridNoRecords } from '@progress/kendo-react-grid';
import { CellRender, GridNoRecord, StatusCell } from '../../../../Shared/GridComponents/CommonComponents';
import WithoutFilterColumnMenu from '../../../../Shared/GridComponents/WithoutFilterColumnMenu';
import { CustomHeaderActionCell, MyCommandCell } from './HelperComponent';
import { clientSettingsData, dateFormatter, errorToastr, successToastr } from '../../../../../HelperMethods';
import ConfirmationModal from '../../../../Shared/ConfirmationModal';
import { ACTIVATE_DEPARMENT_CONFIRMATION_MSG, DEACTIVATE_DEPARMENT_CONFIRMATION_MSG, REMOVE_DEPARTMENT_CONFIRMATION_MSG,Messages } from '../../../../Shared/AppMessages';
import ClientAdminDataService from '../../Service/DataService';
import { State, toODataString } from '@progress/kendo-data-query';
import { KendoFilter } from '../../../../ReusableComponents';
import { RecordStatus, SettingCategory, SETTINGS } from '../../../../Shared/AppConstants';
import { history } from "../../../../../HelperMethods";

import { LocalizationResource} from '../../../../Shared/AppConstants';
import { LocalizationHelper } from '../../../../../Localization/helpers/LocalizationHelper';
import {
    MANAGE_SCHEDULE
} from "../../../../Shared/ApiUrls";
export interface DepartmentProps {
    locationId: string;
}

export interface DepartmentState {
    clientId: string;
    showLoader?: boolean;
    locationDepts: any[];
    dataState?: any;
    totalDepartment: number;
    showRemoveConfirmationModal?: boolean;
    ifAllSelected?: boolean;
    selectedIds: any;
    selectedItems: any;
    showRemoveSelectedModal?: boolean;
    showActivateConfirmationModal?: boolean;
    showDeactivateConfirmationModal?: boolean;
    shiftScheduling?: boolean;
}

const initialDataState = {
    skip: 0,
    take: 10,
};

class Department extends Component<DepartmentProps, DepartmentState> {
    private userObj: any = JSON.parse(localStorage.getItem("user"));
    CustomHeaderActionCellTemplate: any;
    CommandCell;
    public dataItem: any;
    editField = "inEdit";
    public isSubmit = false;
    private originalLevels = [];
    constructor(props: DepartmentProps) {
        super(props);
        this.state = {
            clientId: auth.getClient(),
            locationDepts: [],
            totalDepartment: 0,
            selectedIds: [],
            selectedItems: [],
            dataState: initialDataState,
            shiftScheduling: false
        }
        this.initializeHeaderCell();
    }

    componentDidMount() {
        this.getClientSetting(this.state.clientId);
        if (this.props.locationId) {
            this.setState({ showLoader: true });
            this.getDepartment(this.state.dataState);
        }
    }

    getDepartment = (dataState) => {
        var queryStr = `${toODataString(dataState, { utcDates: true })}`;

        const { locationId } = this.props;
        var queryStr = `${toODataString(dataState)}`;
        let queryParams = `locId eq ${locationId}`;

        var finalQueryString = KendoFilter(dataState, queryStr, queryParams);

        ClientAdminDataService.getClientLocationDepartment(finalQueryString)
            .then((res: any) => {
                this.setState({
                    locationDepts: res.data,
                    dataState: dataState,
                    showLoader: false
                });
                this.getLocationDepartmentCount(dataState);
                this.originalLevels = res.data;
            });
    }

    getLocationDepartmentCount = (dataState) => {
        const { locationId } = this.props;

        var finalState: State = {
            ...dataState,
            take: null,
            skip: 0,
        };
        var queryStr = `${toODataString(finalState)}`;
        let queryParams = `locId eq ${locationId}`;

        var finalQueryString = KendoFilter(dataState, queryStr, queryParams);
        ClientAdminDataService.getClientLocationDepartment(finalQueryString).then((res: any) => {
            this.setState({
                totalDepartment: res.data.length
            });
        });

    }

    initializeHeaderCell = () => {
        this.CustomHeaderActionCellTemplate = CustomHeaderActionCell({
            add: this.addNew
        });
    };

    getClientSetting = (id) => {
        this.setState({ showLoader: true })

        clientSettingsData(id, SettingCategory.SCHEDULING, SETTINGS.SHIFT_SCHEDULING, (response) => {
            this.setState({ shiftScheduling: response }, () => {
                this.initializeActionCell(this.state.shiftScheduling);
            });
        });
    };

    initializeActionCell = (shiftScheduling) => {
        this.CommandCell = MyCommandCell({
            edit: this.enterEdit,
            remove: (dataItem) => this.setState({ showRemoveConfirmationModal: true }, () => this.dataItem = dataItem),
            add: this.add,
            discard: this.discard,
            update: this.update,
            cancel: this.cancel,
            editField: this.editField,
            updateStatus: this.showActiveDeactiveModal,
            redirectTo: this.redirectTo,
            viewSchedule: this.viewSchedule,
            shiftScheduling: shiftScheduling
        });
    };

    showActiveDeactiveModal = (dataItem) => {
        this.dataItem = dataItem;
        if (dataItem.status == 'Active') {
            this.setState({ showDeactivateConfirmationModal: true });
        } else if (dataItem.status == 'Inactive') {
            this.setState({ showActivateConfirmationModal: true });
        }
    }


    addNew = () => {
        this.isSubmit = false;
        const newDataItem = { inEdit: true, intId: this.generateId(this.state.locationDepts), status: "Draft", createdDate: dateFormatter(new Date()), createdByName: this.userObj.userFullName };
        this.setState({
            locationDepts: [newDataItem, ...this.state.locationDepts]
        });
    };

    enterEdit = (dataItem) => {
        this.isSubmit = false;
        this.setState({
            locationDepts: this.state.locationDepts.map(item =>
                item.intId === dataItem.intId ?
                    { ...item, inEdit: true } : item
            )
        });
    }

    checkDuplicate = (name) => {
        let nameExists = this.state.locationDepts.filter(i => i.name && i.name.toLowerCase().trim() == name.toLowerCase().trim())
        if (nameExists.length > 1) {
            return false;
        }
        else {
            return true;
        }
    }

    add = (dataItem, dataIndex) => {
        this.isSubmit = true;
        if (this.checkDuplicate(dataItem.name)) {
            if ((dataItem.name && dataItem.name.trim() && dataItem.name.length <= 100)) {
                dataItem.inEdit = undefined;
                dataItem.intId = this.generateId(this.originalLevels);

                this.originalLevels.unshift(dataItem);
                this.setState({
                    locationDepts: [...this.state.locationDepts]
                });
            }
        }
        else {
            errorToastr(Messages.DEPARTMENT_ALREADY_EXISTS_MSG);
        }
    };

    generateId = data => data.reduce((acc, current) => Math.max(acc, current.intId), 0) + 1;

    remove = (dataItem) => {
        const data = [...this.state.locationDepts];
        this.removeItem(data, dataItem);

        this.setState({ locationDepts: data, showRemoveConfirmationModal: false });
    }

    removeItem(data, item) {
        let index = data.findIndex(p => p === item || (item.id && p.id === item.id));
        if (index >= 0) {
            data.splice(index, 1);
        }
    }

    update = (dataItem) => {
        this.isSubmit = true;
        if (this.checkDuplicate(dataItem.name)) {
            if ((dataItem.name && dataItem.name.trim() && dataItem.name.length <= 100)) {
                const data = [...this.state.locationDepts];
                const updatedItem = { ...dataItem, inEdit: undefined };

                this.updateItem(data, updatedItem);

                this.setState({ locationDepts: data });
            }
        }
        else {
            errorToastr(Messages.DEPARTMENT_ALREADY_EXISTS_MSG);
        }
    }

    updateItem = (data, item) => {
        let index = data.findIndex(p => p === item || (item.id && p.id === item.id));
        if (index >= 0) {
            data[index] = { ...item };
        }
    }

    cancel = (dataItem) => {
        const originalItem = this.originalLevels.find((p) => p.id === dataItem.id);
        originalItem["inEdit"] = undefined;
        const data = this.state.locationDepts.map((item) => item.id === originalItem.id ? originalItem : item);
        this.setState({ locationDepts: data });
    }

    discard = dataItem => {
        const data = [...this.state.locationDepts];
        this.removeItem(data, dataItem);

        this.setState({ locationDepts: data });
    };

    viewSchedule = dataItem => {
        const url = MANAGE_SCHEDULE.replace(":deptId", dataItem.id).replace(":locId", dataItem.locId).replace(":clientId", this.state.clientId);
        history.push(url);
    };

    onDataStateChange = (changeEvent) => {
        if (this.props.locationId) {
            this.getDepartment(changeEvent.dataState);
        }
    };

    itemChange = (event) => {
        const data = this.state.locationDepts.map(item =>
            item.intId === event.dataItem.intId ?
                { ...item, [event.field]: event.value } : item
        );

        this.setState({ locationDepts: data });
    }

    getDepartmentData() {
        let hasUnsavedData = this.state.locationDepts.filter(i => i.inEdit == true).length > 0;
        return ({ data: this.state.locationDepts, hasError: hasUnsavedData ? true : false });
    }

    updateStatus = (dataItem: any, statusId: number) => {
        const { locationId } = this.props;

        ClientAdminDataService.deleteClientLocationDepartment(locationId, dataItem.id, statusId)
        .then((res) => {
            let message;
            if (statusId == RecordStatus.ACTIVE){
                message = Messages.CLIENT_DEPARTMENT_ACTIVE_SUCCESS_MSG;
            }

            if (statusId == RecordStatus.DELETE){
                message = Messages.CLIENT_DEPARTMENT_REMOVE_SUCCESS_MSG;
            }

            if (statusId == RecordStatus.INACTIVE){
                message = Messages.CLIENT_DEPARTMENT_INACTIVE_SUCCESS_MSG;
            }
            successToastr(message);

                this.getDepartment(this.state.dataState);
                this.setState({
                    showActivateConfirmationModal: false,
                    showDeactivateConfirmationModal: false,
                    showRemoveConfirmationModal: false
                });
            })
            .catch(() => {
                this.setState({
                    showActivateConfirmationModal: false,
                    showDeactivateConfirmationModal: false,
                    showRemoveConfirmationModal: false
                });
            });
    }

    redirectTo = (dataItem) => {
        let locationId = this.props.locationId;
        let departmentId = dataItem.id;
        history.push(`/admin/location/${locationId}/department/${departmentId}/shifts`);
    }

    render() {
        const { locationDepts, dataState, totalDepartment } = this.state;
        return (
            <>
                <div className="">
                    <div className="row mt-2">
                        <div className="col-12" id="nameyoursearch">
                            <div className="createjoborderstep4-a" id="createjoborderstep">
                                <div className="table-responsive tableShadow myOrderContainer-dropdownList">
                                    <Grid
                                        className="kendo-grid-custom k-widget lastchild global-action-grid-lastchild"
                                        style={{ height: 'auto' }}
                                        sortable={true}
                                        pageable={{ pageSizes: true }}
                                        onDataStateChange={this.onDataStateChange}
                                        onItemChange={this.itemChange}
                                        editField="inEdit"
                                        //selectedField="selected"
                                        data={this.state.locationDepts}
                                        {...dataState}
                                        total={totalDepartment}
                                        filterable={false}
                                        columnMenu={false}
                                    >
                                        <GridNoRecords>{GridNoRecord(this.state.showLoader, true)}</GridNoRecords>

                                        <GridColumn
                                            sortable={true}
                                            filterable={false}
                                            field="name"
                                            title={LocalizationHelper.getLocalizedTitle(LocalizationResource.Department_Label, "Department")+" Name"}
                                            className="task-form-control task-form-control-Tasks"
                                            columnMenu={WithoutFilterColumnMenu}
                                        />
                                        <GridColumn
                                            field="createdDate"
                                            filter="date"
                                            format="{0:d}"
                                            editor="date"
                                            title="Created Date"
                                            columnMenu={WithoutFilterColumnMenu}
                                            cell={(props) => CellRender(props, "Created Date")}
                                        />
                                        <GridColumn
                                            field="createdByName"
                                            title="Created By"
                                            cell={(props) => CellRender(props, "Created By")}
                                            columnMenu={WithoutFilterColumnMenu}
                                        />
                                        <GridColumn
                                            field="status"
                                            title="Status"
                                            columnMenu={WithoutFilterColumnMenu}
                                            cell={StatusCell}
                                        />
                                        <GridColumn
                                            sortable={false}
                                            cell={this.CommandCell}
                                            width="110px"
                                            headerCell={this.CustomHeaderActionCellTemplate}
                                        />
                                    </Grid>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ConfirmationModal
                        message={REMOVE_DEPARTMENT_CONFIRMATION_MSG()}
                        showModal={this.state.showRemoveConfirmationModal}
                        handleYes={() => {
                            if (this.dataItem.id) {
                                return this.updateStatus(this.dataItem, 2);
                            }
                            return this.remove(this.dataItem);
                        }}
                        handleNo={() => {
                            this.setState({ showRemoveConfirmationModal: false });
                        }}
                    />

                    <ConfirmationModal
                        message={ACTIVATE_DEPARMENT_CONFIRMATION_MSG()}
                        showModal={this.state.showActivateConfirmationModal}
                        handleYes={() => this.updateStatus(this.dataItem, 1)}
                        handleNo={() => {
                            this.setState({ showActivateConfirmationModal: false });
                        }}
                    />

                    <ConfirmationModal
                        message={DEACTIVATE_DEPARMENT_CONFIRMATION_MSG()}
                        showModal={this.state.showDeactivateConfirmationModal}
                        handleYes={() => this.updateStatus(this.dataItem, 0)}
                        handleNo={() => {
                            this.setState({ showDeactivateConfirmationModal: false });
                        }}
                    />
                </div>
            </>
        );
    }
}


export default Department;
